<template>
  <ele-form
    v-model="frender.formScriptData"
    :form-desc="filteredFormDesc"
    :formAttrs="{ size: 'small' }"
    :isShowBackBtn="false"
    :isShowSubmitBtn="false"
    :span="20"
    labelPosition="top"
  ></ele-form>
</template>
<script>
import searchMixin from "./components/search-mixin";
import { changeFormDescLabel } from "../../utils";
export default {
  inject: ["frender"],
  mixins: [searchMixin],
  computed: {
    formDesc() {
      return changeFormDescLabel(this.frender.formScript.config);
    }
  }
};
</script>
